export const rolesRequest_actionType = {
    ROLES_REQUEST_START: "ROLES_REQUEST_START",
    ROLES_REQUEST_SUCCESS: "ROLES_REQUEST_SUCCESS",
    ROLES_REQUEST_ERROR: "ROLES_REQUEST_ERROR",
    ROLES_REQUEST_RESET: "ROLES_REQUEST_RESET"
};